import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//*MUI
import { Box, Divider } from '@mui/material';

//*redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../Redux Store/actions';

//*files
import cssClasses from './Sustenance.module.css';
import DropDown from '../../../Subcomponents/DropDown';
import SearchBar from '../../../Subcomponents/Search';
import ProjectIcon from '../../../Assets/Images/Sustenance/ProjectIcon.svg';
import Datagrid from '../../../Subcomponents/Datagrid';
import { DataGrid } from '@mui/x-data-grid';
import {
  getAssignedProjects,
  getProjectsForPagination,
} from '../../../Services/SustenanceService';
import EmptyState from '../../../Assets/Images/Common/noProjectFound.svg';
import {
  setAlotSustananceGlobalUnitAvailable,
  setAlotSustananceGlobalRoute,
  getAlotSustananceGlobalRoute,
} from '../../../Services/StoredSessionData';
import { debounce } from 'lodash';

const dataGridStyles = {
  '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  border: '1px solid #EAECF0 !important',
  fontWeight: '400',
  fontSize: '1.4rem',
  lineHeight: '2rem',
  color: '#667085',
  fontFamily: 'Inter-Medium',
  borderRadius: '8px',
  '& div[data-colindex="1"]': {
    color: '#101828',
    fontWeight: '500',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    '& .MuiDataGrid-row': {
      borderBottom: '1px solid #EAECF0',
      background: '#FFFFFF',
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: '1rem',

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      borderBottom: '1px solid #EAECF0',
      backgroundColor: '#FFFFFF',
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  '& .MuiDataGrid-iconSeparator ': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader:hover': {
    '& .MuiDataGrid-menuIcon': {
      visibility: 'hidden',
    },
  },

  '&  .MuiDataGrid-columnHeaders': {
    background: '#F9FAFB',
    /* Gray/200 */
    border: '1px solid #EAECF0',
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: '1rem',
    borderBottom: '6px solid #EAECF0',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-checkboxInput': {
    '& svg': {
      width: '2rem',
      height: '2rem',
      background: '#FFFFFF',
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  '& .MuiDataGrid-footerContainer': {
    '& .MuiTablePagination-displayedRows ': {
      display: 'none',
    },
    '& .MuiDataGrid-selectedRowCount': {
      visibility: 'hidden ',
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: 'none',
    cursor: 'none',
  },
  "& [title='Go to previous page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to next page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: '1rem',
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: '1rem',
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 4rem',

    '&:focus': {
      outline: 'none',
    },
  },
  '&  .MuiDataGrid-row ': {
    maxHeight: '72px !important',
    minHeight: '72px !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 4rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiButtonBase-root': {
    fontSize: '1.6rem',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 2rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 1rem',

    '&:focus': {
      outline: 'none',
    },
  },
};
function Sustenance() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [search, setSearch] = useState('');
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState('Latest First');
  const [totalCount, setTotalCount] = useState(0);
  const [pageMaintain, setPageMaintain] = useState(0);
  const [Projects, setProjects] = useState([]);
  const [NoProjectFound, setNoProjectsFound] = useState(null);
  const [finalClickInfo, setFinalClickInfo] = useState(null);
  const [TotalProjectsCount, setTotalProjectsCount] = useState(0);

  useEffect(() => {
    dispatch(action.activeMenu('sustenance'));
    getAllProjectsFromServer(0, false, search, drpDownSelectedVal);
  }, []);

  let SustenanceAccess = [];
  SustenanceAccess = Object.keys(
    loggedInUser?.roleId?.accessibleTabs?.Sustenance
  );
  console.log('Sustenance-Access', { SustenanceAccess });
  let AccessTab = loggedInUser?.roleId?.accessibleTabs?.Sustenance.isAccessible;
  console.log('check accessible', AccessTab);
  console.log('length-check', SustenanceAccess.length);

  let mainTabAccess = Object.keys(loggedInUser?.roleId?.accessibleTabs);
  console.log({ mainTabAccess });

  function goToProject(projectId) {
    if (
      AccessTab === true &&
      SustenanceAccess.length > 1 &&
      mainTabAccess.includes('Sustenance')
    ) {
      console.log('project-Name', projectId);
      if (getAlotSustananceGlobalRoute()) {
        navigate(`/home/Sustenance/Details/${projectId}/DirectAllotment`);
      } else {
        if (
          loggedInUser?.roleId?.accessibleTabs?.Sustenance?.[
            'Direct Allotment'
          ] !== false
        ) {
          navigate(`/home/Sustenance/Details/${projectId}/DirectAllotment`);
        } else {
          navigate(
            `/home/Sustenance/Details/${projectId}/${
              Object.keys(loggedInUser?.roleId?.accessibleTabs?.Sustenance)[1]
            }`
          );
        }
      }
      setAlotSustananceGlobalUnitAvailable(false);
    }
  }

  const ProjectColumns = [
    {
      field: 'projectName',
      headerName: 'Project name',
      width: 530,
      renderCell: (params) => {
        return (
          <Box
            className={cssClasses.SubContainer}
            style={{ cursor: 'pointer' }}
            onClick={() => goToProject(params.row.projectId)}
          >
            <img src={ProjectIcon} alt={''} />
            <Box ml={1} mt={1} className={cssClasses.innerTitle}>
              {params?.row?.projectName ? params?.row?.projectName : ''}
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'Location',
      headerName: 'Location',
      width: 600,
      renderCell: (params) => {
        return (
          <Box
            className={cssClasses.SubContainer}
            style={{ cursor: 'pointer' }}
            // onClick={() => {
            //   goToProject(params.row.projectId);
            // }}
          >
            <Box m={2} className={cssClasses.innerTitle}>
              {`${params.row.addressLine1} ${params.row.addressLine2} ${
                params.row.addressLine3 === null ? '' : params.row.addressLine3
              }`}
            </Box>
          </Box>
        );
      },
    },
  ];

  function getAllProjectsFromServer(
    pageNumber,
    merge,
    search,
    drpDownSelectedVal
  ) {
    if (loggedInUser.roleId.level === 1) {
      getProjectsForPagination(
        search,
        pageNumber * pageSize,
        pageNumber * pageSize + pageSize - 1,
        drpDownSelectedVal,
        true
      )
        .then((response) => {
          console.log('Data', response);
          if (response.count > 0) {
            setNoProjectsFound(true);
          } else {
            setNoProjectsFound(false);
          }
          const projectArr = response.data
            .filter((f) => f.isPublished === true)
            .map((el, index) => ({
              // response = response.data.filter(f => f.isCompleted === true).map((el, index) => ({
              ...el,
              id: el.projectId,
              index: index,
            }));
          if (merge) {
            setProjects((pre) => [...pre, ...projectArr]);
            console.log('response', Projects);
          } else {
            setProjects([...projectArr]);
          }

          console.log('After setting data', Projects);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      getAssignedProjects(
        search,
        pageNumber * pageSize,
        pageNumber * pageSize + pageSize - 1,
        drpDownSelectedVal,
        loggedInUser.userId,
        true
      )
        .then((response) => {
          console.log('Data', response);
          setTotalProjectsCount(response.count);
          if (response.count > 0) {
            setNoProjectsFound(true);
          } else {
            setNoProjectsFound(false);
          }
          // response = response.data.filter(f => f.isCompleted === true).map((el, index) => ({
          //   ...el,
          //   id: el.projectId,
          //   index: index,
          // }));
          let projects = [];
          response.data.forEach((proj) => {
            proj.projectId.id = proj.projectId.projectId;
            projects.push(proj.projectId);
          });
          if (merge) {
            setProjects((pre) => [...pre, ...projects]);
            // setProjects((pre) => [...pre, ...response]);
          } else {
            setProjects(projects);
            // setProjects(response)
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  function getMoreData(passPageNumber) {
    setPageNumber(passPageNumber);
    getAllProjectsFromServer(passPageNumber, true, search, drpDownSelectedVal);
  }

  const debouncedFetchSearchData = debounce((e) => {
    setSearch(e.target.value);
    getAllProjectsFromServer(
      pageNumber,
      false,
      e.target.value,
      drpDownSelectedVal
    );
  }, 800);

  return (
    <Box className={cssClasses.Container}>
      <Box mb={1}>
        <Box className={cssClasses.SubContainer}>
          <Box className={cssClasses.DivContainer}>
            <Box className={cssClasses.HeaderTitle}>Sustenance</Box>
          </Box>
        </Box>
      </Box>

      <Divider />

      <Box margin={'1rem 0'}>
        <Box className={cssClasses.ProjectTitle}>
          {Projects.length > 1 ? (
            <Box component={'span'}>{Projects.length} Projects</Box>
          ) : (
            <Box component={'span'}>{Projects.length} Project</Box>
          )}
        </Box>

        <Box margin={'1rem 0'}>
          <Box className={cssClasses.SubTitle}>Sort by</Box>
          <Box className={cssClasses.SubContainer} marginTop={'0.4rem'}>
            <Box width={'25rem'}>
              <DropDown
                list={[
                  'Name Ascending',
                  'Name Descending',
                  'Latest First',
                  'Oldest First',
                ]}
                style={{
                  selectedColor: '#175CD3',
                  background: '#E8F0FE',
                }}
                selectedValue={drpDownSelectedVal}
                onChangeSelect={(_value) => {
                  setDrpDownSelectedVal(_value);
                  getAllProjectsFromServer(0, false, search, _value);
                }}
              />
            </Box>
            <Box marginLeft={'auto'}>
              <SearchBar
                id={'StudentSearch'}
                value={search}
                placeholder={'Search by project name'}
                search={debouncedFetchSearchData}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      {Projects?.length > 0 && (
        <Box className={cssClasses.GridWrapper}>
          {/* <Datagrid
            rows={Projects}
            columns={ProjectColumns}
            hideFooter={false}
            handleCellClick={(params) => {
              goToProject(params.row.projectId)
            }}
            pageChanged={pageChanged}
          /> */}

          <DataGrid
            rows={Projects}
            columns={ProjectColumns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            page={pageMaintain}
            onPageChange={(_page) => {
              setPageMaintain(_page);
              if (pageNumber < _page) {
                getMoreData(_page);
              }
            }}
            sx={[dataGridStyles]}
          />
        </Box>
      )}

      {NoProjectFound === false && (
        <Box>
          <Box className={cssClasses.noDataMsg}>
            <Box className={cssClasses.emptyIcon}>
              <img src={EmptyState} alt='No Wings' />
            </Box>
            <Box className={cssClasses.emptyTitle}>No Projects found</Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default Sustenance;
